<template>
  <b-form-row>
    <b-modal size="xl" button-size="sm" ref="finder" hide-footer :id="this.id" :title="title">
      <MarcaList :prefix="updatedPrefix" :codEmpresa="codEmpresa" @onDblClickMarca="marcaSelect" />
    </b-modal>

    <lg-form-input-finder :value="computedValue" @input="updateValue" fieldDescription="descricao" :label="label"
      invalidFeedback="Marca deve ser informada!" description="" @handleClean="handleClean" :error="error" :cols="cols"
      :disabled="disabled">
      <template #prepend>
        <b-button :disabled="disabled" @click="show" class="btn-input-finder" pressed>
          <b-icon icon="search" />
        </b-button>
      </template>
    </lg-form-input-finder>
  </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"
import MarcaList from "../../modules/cadastros/marca/MarcaList.vue"

export default {
  components: { LgFormInputFinder, MarcaList },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    id: String,
    prefix: Array,
    codEmpresa: Number,
    value: Object,
    cols: String,
    label: String,
    error: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      internalValue: this.value || {},
    };
  },
  watch: {
    value(newValue) {
      this.internalValue = newValue;
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.internalValue;
      },
      set(newValue) {
        this.internalValue = newValue;
      },
    },
    updatedPrefix() {
      return [...this.prefix, "Marca"];
    },
    title() {
      return this.updatedPrefix.join(" > ");
    },
  },
  methods: {
    show() {
      this.$bvModal.show(this.id);
    },
    updateValue(newValue) {
      this.computedValue = newValue;
      this.$emit("input", newValue);
    },
    handleClean() {
      this.computedValue = {};
      this.$emit("input", {});
    },
    marcaSelect(item) {
      this.computedValue = item;
      this.$emit("input", item);
      this.$bvModal.hide(this.id);
    },
  },
};
</script>
